import { render, staticRenderFns } from "./Video_index_graph.vue?vue&type=template&id=28b216e4&scoped=true"
import script from "./Video_index_graph.vue?vue&type=script&lang=js"
export * from "./Video_index_graph.vue?vue&type=script&lang=js"
import style0 from "./Video_index_graph.vue?vue&type=style&index=0&id=28b216e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b216e4",
  null
  
)

export default component.exports